export default __webpack_public_path__ + "media/header.39058277.png";